<div class="gallery" id="gallery">
  <div class="container">
    <h2 class="section-heading">{{ 'gallery.heading' | translate }}</h2>
    <p class="section-subheading">{{ 'gallery.subheading' | translate }}</p>

    <div class="gallery-grid">
      @for (image of images; track image; let i = $index) {
      <button type="button" class="gallery-tile" [ngClass]="image.orientation" (click)="openViewer(i)">
        <img [src]="image.src" [alt]="image.captionKey | translate" loading="lazy" />
      </button>
      }
    </div>
  </div>
</div>

@if (isViewerOpen) {
<div class="gallery-viewer" (click)="closeViewer()">
  <button type="button" class="viewer-close" (click)="closeViewer(); $event.stopPropagation()" aria-label="Close">
    <svg-icon src="./assets/images/svg-icons/close-white.svg" [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
  </button>

  <div class="viewer-stage" (click)="$event.stopPropagation()">
    <button type="button" class="viewer-nav prev" (click)="showPrev()" aria-label="Previous image">
      <svg-icon src="./assets/images/svg-icons/back.svg" [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"></svg-icon>
    </button>

    <div class="viewer-frame">
      <img [src]="selectedImage.src" [alt]="selectedImage.captionKey | translate" class="viewer-image" />

      <div class="viewer-caption" [ngClass]="{ collapsed: !isCaptionVisible }">
        <p class="viewer-caption-text">{{ selectedImage.captionKey | translate }}</p>
      </div>

      <button type="button" class="viewer-caption-toggle" [ngClass]="{ collapsed: !isCaptionVisible }" (click)="toggleCaption()" aria-label="Toggle description">
        <svg-icon src="./assets/images/svg-icons/angle-down.svg" [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"></svg-icon>
      </button>
    </div>

    <button type="button" class="viewer-nav next" (click)="showNext()" aria-label="Next image">
      <svg-icon src="./assets/images/svg-icons/front.svg" [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"></svg-icon>
    </button>
  </div>

  <div class="viewer-thumbnails" (click)="$event.stopPropagation()">
    @for (image of images; track image; let i = $index) {
    <button type="button" class="viewer-thumbnail" [ngClass]="{ active: i === selectedIndex }" (click)="selectImage(i)">
      <img [src]="image.src" [alt]="image.captionKey | translate" loading="lazy" />
    </button>
    }
  </div>
</div>
}